import { Route } from '@angular/router';

export const outletLoggedIn = (options: Route = {}): Route => {
    return Object.assign({
        outlet: "logged_in",
    }, options);
};
